import mock from '../mock'

/* eslint-disable */
const data = {
  emails: [
    {
      id: 1,
      from: {
        email: 'nguyen.van.an@ioc.gov.vn',
        name: 'Nguyễn Văn An',
        avatar: require('@src/assets/images/avatars/1.png').default
      },
      to: [
        {
          name: 'tôi',
          email: 'tran.thi.binh@ioc.gov.vn'
        }
      ],
      subject: 'Báo cáo chỉ tiêu dân số tháng 12',
      cc: [],
      bcc: [],
      message:
        '<p>Kính gửi chị Bình,</p><p>Tôi xin gửi báo cáo cập nhật các chỉ tiêu IOC lĩnh vực Dân số & Dân cư cho tháng 12 này. Theo dữ liệu tổng hợp từ hệ thống IOC, tổng dân số toàn thành phố hiện đạt 9.218.000 người, tăng 0,3% so với tháng trước. Tỷ lệ tăng dân số tự nhiên đang ở mức 1,12%/năm, mật độ dân số đạt 4.292 người/km².</p><p>Đáng chú ý, tỷ lệ nhập cư trong tháng tăng nhẹ 0,05% so với cùng kỳ năm ngoái. Tỷ lệ hộ gia đình có trẻ em hiện chiếm 38,7%, tỷ lệ hộ có người cao tuổi chiếm 22,4%. Đề nghị chị xem xét và phê duyệt báo cáo để trình lãnh đạo.</p><p>Trân trọng,<br/>Nguyễn Văn An<br/>Phòng Quản lý Dân số - IOC</p>',
      attachments: [
        {
          fileName: 'bao-cao-dan-so-t12.txt',
          thumbnail: require('@src/assets/images/icons/txt.png').default,
          url: '',
          size: '5mb'
        },
        {
          fileName: 'thong-ke-dan-so.xls',
          thumbnail: require('@src/assets/images/icons/xls.png').default,
          url: '',
          size: '10mb'
        }
      ],
      isStarred: false,
      labels: ['private'],
      time: 'Mon Dec 10 2018 07:46:00 GMT+0000 (GMT)',
      replies: [],
      folder: 'inbox',
      isRead: true
    },
    {
      id: 2,
      from: {
        email: 'tran.thi.binh@ioc.gov.vn',
        name: 'Trần Thị Bình',
        avatar: require('@src/assets/images/avatars/2.png').default
      },
      to: [
        {
          name: 'tôi',
          email: 'le.minh.chau@ioc.gov.vn'
        }
      ],
      subject: 'Cập nhật chỉ tiêu giao thông - Tình trạng ùn tắc',
      cc: ['pham.duc.dung@ioc.gov.vn'],
      bcc: ['hoang.thi.lan@ioc.gov.vn'],
      message:
        '<p>Kính gửi anh Châu,</p><p>Theo dõi hệ thống IOC lĩnh vực Giao thông, tôi ghi nhận một số bất thường về chỉ tiêu ùn tắc giao thông trong tuần qua. Số điểm ùn tắc trên địa bàn thành phố đã tăng lên 47 điểm, tăng 12% so với trung bình tháng trước. Thời gian trung bình di chuyển trên các tuyến đường chính tăng thêm 18 phút vào giờ cao điểm sáng.</p><p>Số lượng phương tiện lưu thông trên đường Nguyễn Huệ và Lê Lợi vào giờ cao điểm đạt trên 3.200 phương tiện/giờ, vượt ngưỡng cảnh báo. Hệ thống camera giao thông đã ghi nhận 23 vụ vi phạm tín hiệu đèn đỏ và 15 vụ đi ngược chiều trong ngày hôm qua.</p><p>Đề nghị anh phối hợp với lực lượng CSGT để tăng cường kiểm soát tại các điểm ùn tắc trọng yếu. Tôi sẽ cập nhật thêm số liệu vào cuối ngày.</p><p>Trân trọng,<br/>Trần Thị Bình<br/>Trung tâm Giám sát Giao thông - IOC</p>',
      attachments: [],
      isStarred: true,
      labels: ['company', 'private'],
      time: 'Mon Dec 10 2018 07:55:00 GMT+0000 (GMT)',
      replies: [],
      folder: 'inbox',
      isRead: true
    },
    {
      id: 3,
      from: {
        email: 'le.minh.chau@ioc.gov.vn',
        name: 'Lê Minh Châu',
        avatar: require('@src/assets/images/avatars/3.png').default
      },
      to: [
        {
          name: 'tôi',
          email: 'pham.duc.dung@ioc.gov.vn'
        },
        {
          name: 'Phòng An ninh',
          email: 'an.ninh@ioc.gov.vn'
        }
      ],
      subject: 'Cảnh báo chỉ tiêu an ninh trật tự khu vực trung tâm',
      cc: [],
      bcc: [],
      message:
        '<p>Kính gửi anh Dũng,</p><p>Hệ thống IOC lĩnh vực An ninh ghi nhận gia tăng bất thường về số vụ vi phạm trật tự công cộng tại khu vực trung tâm thành phố trong 48 giờ qua. Cụ thể, số vụ trộm cắp tăng 15%, số vụ gây rối trật tự tăng 22% so với tuần trước.</p><p>Camera an ninh tại 12 điểm trên địa bàn quận 1 và quận 3 đã ghi nhận các đối tượng khả nghi hoạt động. Tỷ lệ giải quyết tin báo trong ngày đạt 78%, thấp hơn chỉ tiêu 90%. Lực lượng tuần tra đêm cần được tăng cường tại các khu vực công viên và phố đi bộ.</p><p>Đề nghị anh phê duyệt phương án tăng cường tuần tra và kiểm tra hệ thống camera để đảm bảo chỉ tiêu an ninh theo kế hoạch.</p><p>Trân trọng,<br/>Lê Minh Châu<br/>Ban Giám sát An ninh - IOC</p>',
      attachments: [],
      isStarred: false,
      labels: ['company'],
      time: 'Mon Dec 10 2018 08:35:00 GMT+0000 (GMT)',
      replies: [],
      folder: 'spam',
      isRead: true
    },
    {
      id: 4,
      from: {
        email: 'pham.duc.dung@ioc.gov.vn',
        name: 'Phạm Đức Dũng',
        avatar: require('@src/assets/images/avatars/4.png').default
      },
      to: [
        {
          name: 'tôi',
          email: 'hoang.thi.lan@ioc.gov.vn'
        }
      ],
      subject: 'Báo cáo chỉ tiêu y tế - Tỷ lệ tiêm chủng và bệnh nhân nhập viện',
      cc: [],
      bcc: [],
      message:
        '<p>Kính gửi chị Lan,</p><p>Tôi xin báo cáo tình hình các chỉ tiêu IOC lĩnh vực Y tế tháng này. Tỷ lệ tiêm chủng đầy đủ cho trẻ em dưới 5 tuổi đạt 94,2%, đạt mục tiêu đề ra. Số bệnh nhân nhập viện tại các bệnh viện công lập trong tuần qua là 12.450 lượt, tăng 8% so với cùng kỳ do thời tiết thay đổi.</p><p>Đáng lo ngại là số ca mắc bệnh sốt xuất huyết tăng 35 ca trong tuần, nâng tổng số lên 412 ca trong tháng. Tỷ lệ giường bệnh/10.000 dân hiện ở mức 28,6, cần tăng cường năng lực thu dung. Hệ thống IOC đã kích hoạt cảnh báo mức độ 2 cho lĩnh vực dịch bệnh truyền nhiễm.</p><p>Đề nghị chị chỉ đạo các đơn vị y tế tăng cường giám sát và phòng chống dịch bệnh theo đúng quy trình.</p><p>Trân trọng,<br/>Phạm Đức Dũng<br/>Phòng Quản lý Y tế - IOC</p>',
      attachments: [
        {
          fileName: 'bao-cao-y-te-thang12.doc',
          thumbnail: require('@src/assets/images/icons/doc.png').default,
          url: '',
          size: '32mb'
        }
      ],
      isStarred: false,
      labels: ['important'],
      time: 'Mon Dec 11 2018 09:04:10 GMT+0000 (GMT)',
      replies: [],
      folder: 'inbox',
      isRead: true
    },
    {
      id: 5,
      from: {
        email: 'hoang.thi.lan@ioc.gov.vn',
        name: 'Hoàng Thị Lan',
        avatar: require('@src/assets/images/avatars/11.png').default
      },
      to: [
        {
          name: 'tôi',
          email: 'vu.quang.minh@ioc.gov.vn'
        }
      ],
      subject: 'Chỉ số AQI vượt ngưỡng - Cảnh báo ô nhiễm môi trường',
      cc: [],
      bcc: [],
      message:
        '<p>Kính gửi anh Minh,</p><p>Hệ thống quan trắc môi trường tích hợp IOC ghi nhận chỉ số AQI (Chỉ số Chất lượng Không khí) tại 5 trạm đo trên địa bàn thành phố đã vượt ngưỡng cảnh báo màu đỏ (AQI > 150) trong 3 giờ liên tiếp sáng nay. Cụ thể, trạm Bình Thạnh ghi nhận AQI đạt 178, trạm Thủ Đức đạt 165.</p><p>Nồng độ bụi mịn PM2.5 đo được là 68,4 µg/m³, gấp 2,7 lần tiêu chuẩn cho phép. Nguồn ô nhiễm chủ yếu đến từ hoạt động giao thông và một số cơ sở sản xuất chưa tuân thủ quy định về khí thải. Tình trạng xử lý rác thải tại một số bãi chôn lấp cũng góp phần làm xấu chất lượng không khí.</p><p>Đề nghị anh phối hợp với Sở Tài nguyên & Môi trường để ban hành khuyến cáo cho người dân và yêu cầu các cơ sở sản xuất giảm công suất.</p><p>Trân trọng,<br/>Hoàng Thị Lan<br/>Ban Giám sát Môi trường - IOC</p>',
      attachments: [],
      isStarred: true,
      labels: ['private'],
      time: 'Tue Dec 12 2018 11:55:00 GMT+0000 (GMT)',
      replies: [],
      folder: 'spam',
      isRead: true
    },
    {
      id: 6,
      from: {
        email: 'vu.quang.minh@ioc.gov.vn',
        name: 'Vũ Quang Minh',
        avatar: require('@src/assets/images/avatars/6.png').default
      },
      to: [
        {
          name: 'tôi',
          email: 'do.thi.thu@ioc.gov.vn'
        }
      ],
      subject: 'Báo cáo chỉ tiêu kinh tế - Thu ngân sách và tăng trưởng',
      cc: [],
      bcc: [],
      message:
        '<p>Kính gửi chị Thu,</p><p>Theo dõi các chỉ tiêu IOC lĩnh vực Kinh tế, tôi xin báo cáo tình hình thu ngân sách và tăng trưởng kinh tế tháng 12. Tổng thu ngân sách nhà nước trên địa bàn đạt 48.350 tỷ đồng, đạt 97,8% kế hoạch tháng. Tốc độ tăng trưởng kinh tế (GRDP) ước đạt 7,2%, cao hơn 0,4% so với mục tiêu đề ra.</p><p>Số doanh nghiệp mới thành lập trong tháng là 3.241 đơn vị, tăng 11% so với cùng kỳ. Số doanh nghiệp giải thể/tạm dừng hoạt động là 892, giảm 5%. Chỉ số sản xuất công nghiệp tăng 8,3%. Hệ thống IOC theo dõi 1.250 doanh nghiệp lớn đang hoạt động ổn định.</p><p>Đề nghị chị tổng hợp và báo cáo lên Ban Chỉ đạo phát triển kinh tế trước ngày 20/12.</p><p>Trân trọng,<br/>Vũ Quang Minh<br/>Phòng Kinh tế - IOC</p>',
      attachments: [],
      isStarred: false,
      labels: ['personal'],
      time: 'Thu Dec 13 2018 08:25:00 GMT+0000 (GMT)',
      replies: [],
      folder: 'trash',
      isRead: true
    },
    {
      id: 7,
      from: {
        email: 'do.thi.thu@ioc.gov.vn',
        name: 'Đỗ Thị Thu',
        avatar: require('@src/assets/images/avatars/1.png').default
      },
      to: [
        {
          name: 'tôi',
          email: 'bui.van.hung@ioc.gov.vn'
        }
      ],
      subject: 'Dự thảo kế hoạch cải thiện chỉ tiêu giáo dục năm học mới',
      cc: [],
      bcc: [],
      message:
        '<p>Kính gửi anh Hùng,</p><p>Tôi xin gửi dự thảo kế hoạch cải thiện các chỉ tiêu IOC lĩnh vực Giáo dục cho năm học 2024-2025. Tỷ lệ học sinh đến trường đúng độ tuổi hiện đạt 97,3% bậc tiểu học, 94,1% bậc THCS và 86,7% bậc THPT. Tỷ lệ tốt nghiệp THPT đạt 98,2%, tuy nhiên tỷ lệ học sinh giỏi chỉ đạt 21,4%, thấp hơn chỉ tiêu 5%.</p><p>Chất lượng giáo dục tại các trường vùng ngoại ô còn chênh lệch đáng kể so với khu vực trung tâm. Cần bổ sung 120 phòng học và 450 giáo viên để đáp ứng nhu cầu. Hệ thống IOC đề xuất 5 giải pháp ưu tiên để nâng cao chỉ tiêu chất lượng giáo dục trong năm học mới.</p><p>Đề nghị anh xem xét và góp ý cho dự thảo để hoàn thiện trước khi trình lãnh đạo.</p><p>Trân trọng,<br/>Đỗ Thị Thu<br/>Phòng Giáo dục - IOC</p>',
      attachments: [],
      isStarred: false,
      labels: ['company'],
      time: 'Fri Dec 14 2018 04:49:23 GMT+0000 (GMT)',
      replies: [],
      folder: 'draft',
      isRead: true
    },
    {
      id: 8,
      from: {
        email: 'bui.van.hung@ioc.gov.vn',
        name: 'Bùi Văn Hùng',
        avatar: require('@src/assets/images/avatars/11.png').default
      },
      to: [
        {
          name: 'tôi',
          email: 'ngo.thi.huong@ioc.gov.vn'
        }
      ],
      subject: 'Chỉ tiêu quy hoạch đô thị - Tình hình cấp phép xây dựng',
      cc: [],
      bcc: [],
      message:
        '<p>Kính gửi chị Hương,</p><p>Báo cáo tình hình thực hiện các chỉ tiêu IOC lĩnh vực Quy hoạch Đô thị tháng 12. Số hồ sơ cấp phép xây dựng tiếp nhận trong tháng là 1.892 hồ sơ, đã xử lý 1.745 hồ sơ (đạt tỷ lệ 92,2%), trong đó cấp phép 1.521 hồ sơ và từ chối 224 hồ sơ do không đáp ứng quy định quy hoạch.</p><p>Tỷ lệ đất xây dựng đúng quy hoạch đạt 87,4%. Có 34 trường hợp xây dựng không phép bị phát hiện và xử lý. Tiến độ các dự án hạ tầng trọng điểm: 3/7 dự án đang đúng tiến độ, 2/7 dự án chậm tiến độ từ 2-3 tháng. Hệ thống IOC đã cập nhật bản đồ quy hoạch số cho 18/22 quận huyện.</p><p>Đề nghị chị theo dõi và đôn đốc các đơn vị đảm bảo tiến độ xử lý hồ sơ theo quy định.</p><p>Trân trọng,<br/>Bùi Văn Hùng<br/>Phòng Quy hoạch - IOC</p>',
      attachments: [],
      isStarred: false,
      labels: ['private'],
      time: 'Tue Dec 15 2018 11:02:28 GMT+0000 (GMT)',
      replies: [],
      folder: 'inbox',
      isRead: false
    },
    {
      id: 9,
      from: {
        email: 'ngo.thi.huong@ioc.gov.vn',
        name: 'Ngô Thị Hương',
        avatar: require('@src/assets/images/avatars/9.png').default
      },
      to: [
        {
          name: 'tôi',
          email: 'ly.van.phong@ioc.gov.vn'
        }
      ],
      subject: 'Chỉ tiêu ngân sách - Phân bổ chi tiêu công và kiểm soát nợ công',
      cc: [],
      bcc: [],
      message:
        '<p>Kính gửi anh Phong,</p><p>Tôi xin cập nhật tình hình thực hiện các chỉ tiêu IOC lĩnh vực Ngân sách tháng này. Tỷ lệ giải ngân vốn đầu tư công đạt 68,5% kế hoạch năm, thấp hơn chỉ tiêu 75% đề ra. Nguyên nhân chủ yếu do vướng mắc trong công tác giải phóng mặt bằng tại 5 dự án lớn.</p><p>Chi thường xuyên đạt 92,3% dự toán, trong đó chi cho giáo dục chiếm 22,4%, y tế 15,1%, an ninh trật tự 8,7%. Nợ công của thành phố hiện ở mức 42,1% GRDP, trong ngưỡng an toàn cho phép. Hệ thống IOC đã cảnh báo 3 đơn vị có nguy cơ vượt dự toán chi vào cuối năm.</p><p>Đề nghị anh chỉ đạo các sở ngành rà soát và đẩy nhanh tiến độ giải ngân trong tháng còn lại của năm.</p><p>Trân trọng,<br/>Ngô Thị Hương<br/>Ban Tài chính Ngân sách - IOC</p>',
      attachments: [],
      isStarred: true,
      labels: ['personal'],
      time: 'Tue Jan 01 2018 18:31:19 GMT+0000 (GMT)',
      replies: [],
      folder: 'trash',
      isRead: false
    },
    {
      id: 10,
      from: {
        email: 'ly.van.phong@ioc.gov.vn',
        name: 'Lý Văn Phong',
        avatar: require('@src/assets/images/avatars/7.png').default
      },
      to: [
        {
          name: 'tôi',
          email: 'dinh.thi.nga@ioc.gov.vn'
        }
      ],
      subject: 'Chỉ tiêu phòng cháy chữa cháy - Đề xuất nâng cấp hệ thống',
      cc: [],
      bcc: [],
      message:
        '<p>Kính gửi chị Nga,</p><p>Theo dõi các chỉ tiêu IOC lĩnh vực An toàn Thành phố, tôi ghi nhận một số vấn đề cần xử lý khẩn trương về năng lực phòng cháy chữa cháy. Số vụ cháy xảy ra trong tháng là 47 vụ, tăng 18% so với tháng trước, trong đó 12 vụ tại khu dân cư và 8 vụ tại cơ sở sản xuất.</p><p>Thời gian phản ứng trung bình của lực lượng PCCC là 8,3 phút, vượt quá ngưỡng chuẩn 7 phút. Tỷ lệ cơ sở được kiểm tra an toàn PCCC trong kỳ đạt 61,2%, thấp hơn chỉ tiêu 80%. Hệ thống IOC đề xuất bổ sung 3 trạm PCCC tại các khu vực xa trung tâm và nâng cấp 12 xe chữa cháy đã hết hạn sử dụng.</p><p>Đề nghị chị trình lãnh đạo phê duyệt đề xuất đầu tư nâng cấp hệ thống PCCC để đảm bảo chỉ tiêu an toàn.</p><p>Trân trọng,<br/>Lý Văn Phong<br/>Ban An toàn Thành phố - IOC</p>',
      attachments: [
        {
          fileName: 'de-xuat-pccc.xls',
          thumbnail: require('@src/assets/images/icons/xls.png').default,
          url: '',
          size: '1mb'
        }
      ],
      isStarred: true,
      labels: ['important'],
      time: 'Tue Jan 03 2018 08:05:33 GMT+0000 (GMT)',
      replies: [],
      folder: 'draft',
      isRead: false
    },
    {
      id: 11,
      from: {
        email: 'dinh.thi.nga@ioc.gov.vn',
        name: 'Đinh Thị Nga',
        avatar: require('@src/assets/images/avatars/4.png').default
      },
      to: [
        {
          name: 'tôi',
          email: 'to.xuan.truong@ioc.gov.vn'
        }
      ],
      subject: 'Chỉ tiêu dịch vụ công - Mức độ hài lòng của người dân',
      cc: [],
      bcc: [],
      message:
        '<p>Kính gửi anh Trường,</p><p>Tôi xin gửi kết quả đo lường chỉ tiêu IOC lĩnh vực Dịch vụ Công tháng 12. Chỉ số hài lòng của người dân về dịch vụ công trực tuyến đạt 82,1%, tăng 3,2% so với tháng trước. Tổng số hồ sơ dịch vụ công tiếp nhận qua hệ thống trực tuyến là 145.320 hồ sơ, tăng 24% so với cùng kỳ năm ngoái.</p><p>Tỷ lệ giải quyết đúng hạn đạt 94,7%. Thủ tục hành chính được giải quyết trước hạn chiếm 68,3%. Tuy nhiên, vẫn còn 3.425 hồ sơ trễ hạn, tập trung chủ yếu ở lĩnh vực đất đai và xây dựng. Hệ thống IOC đã ghi nhận 287 phản ánh của người dân, trong đó 91,3% được xử lý trong ngày.</p><p>Đề nghị anh nghiên cứu và đề xuất giải pháp cải thiện chất lượng giải quyết thủ tục tại các lĩnh vực còn tồn đọng.</p><p>Trân trọng,<br/>Đinh Thị Nga<br/>Phòng Dịch vụ Công - IOC</p>',
      attachments: [
        {
          fileName: 'ket-qua-dich-vu-cong.js',
          thumbnail: require('@src/assets/images/icons/js.png').default,
          url: '',
          size: '29mb'
        }
      ],
      isStarred: false,
      labels: ['company'],
      time: 'Tue Jan 03 2018 01:05:20 GMT+0000 (GMT)',
      replies: [],
      folder: 'trash',
      isRead: true
    },
    {
      id: 12,
      from: {
        email: 'to.xuan.truong@ioc.gov.vn',
        name: 'Tô Xuân Trường',
        avatar: require('@src/assets/images/avatars/2.png').default
      },
      to: [
        {
          name: 'tôi',
          email: 'cao.thi.mai@ioc.gov.vn'
        }
      ],
      subject: 'Chỉ tiêu an toàn thực phẩm - Kết quả kiểm tra định kỳ',
      cc: [],
      bcc: [],
      message:
        '<p>Kính gửi chị Mai,</p><p>Tôi xin báo cáo kết quả kiểm tra định kỳ các chỉ tiêu IOC lĩnh vực An toàn Thực phẩm tháng 12. Đoàn kiểm tra đã tiến hành kiểm tra 1.245 cơ sở sản xuất, chế biến, kinh doanh thực phẩm trên địa bàn. Kết quả: 1.087 cơ sở đạt tiêu chuẩn (87,3%), 158 cơ sở vi phạm bị xử lý.</p><p>Đã xử phạt hành chính 72 cơ sở với tổng số tiền phạt 1,85 tỷ đồng, đình chỉ hoạt động 14 cơ sở và tiêu hủy 2,3 tấn thực phẩm không đảm bảo vệ sinh. Số ca ngộ độc thực phẩm trong tháng là 8 ca (giảm 40% so với tháng trước), không có ca tử vong. Hệ thống IOC cảnh báo nguy cơ tăng ca ngộ độc trong dịp Tết do tăng cường chế biến thực phẩm.</p><p>Đề nghị chị chỉ đạo tăng cường kiểm tra dịp Tết theo kế hoạch đã được phê duyệt.</p><p>Trân trọng,<br/>Tô Xuân Trường<br/>Ban An toàn Thực phẩm - IOC</p>',
      attachments: [],
      isStarred: false,
      labels: ['personal'],
      time: 'Tue Jan 04 2018 21:26:54 GMT+0000 (GMT)',
      replies: [],
      folder: 'sent',
      isRead: true
    },
    {
      id: 13,
      from: {
        email: 'cao.thi.mai@ioc.gov.vn',
        name: 'Cao Thị Mai',
        avatar: require('@src/assets/images/avatars/10.png').default
      },
      to: [
        {
          name: 'tôi',
          email: 'duong.van.khoa@ioc.gov.vn'
        }
      ],
      subject: 'Đề xuất cải thiện chỉ tiêu người cao tuổi và người khuyết tật',
      cc: [],
      bcc: [],
      message:
        '<p>Kính gửi anh Khoa,</p><p>Tôi xin đề xuất các giải pháp cải thiện chỉ tiêu IOC lĩnh vực Người cao tuổi và Người khuyết tật. Hiện tại, số người cao tuổi trên 60 tuổi là 892.450 người, chiếm 9,7% dân số. Tỷ lệ người cao tuổi có thẻ bảo hiểm y tế đạt 96,8%. Tuy nhiên, chỉ 42,1% người cao tuổi tham gia các câu lạc bộ dưỡng sinh và sinh hoạt cộng đồng.</p><p>Số người khuyết tật đang được hưởng trợ cấp xã hội là 124.680 người. Tỷ lệ người khuyết tật có việc làm đạt 31,4%, thấp hơn chỉ tiêu 40%. Còn 23 công trình công cộng chưa có lối đi dành riêng cho người khuyết tật theo quy định. Hệ thống IOC ghi nhận 1.245 yêu cầu hỗ trợ từ người cao tuổi và người khuyết tật đang chờ xử lý.</p><p>Đề nghị anh xem xét và phê duyệt kế hoạch hành động cải thiện các chỉ tiêu này trong quý 1/2024.</p><p>Trân trọng,<br/>Cao Thị Mai<br/>Phòng Xã hội - IOC</p>',
      attachments: [],
      isStarred: false,
      labels: ['important'],
      time: 'Tue Jan 05 2018 19:00:00 GMT+0000 (GMT)',
      replies: [],
      folder: 'draft',
      isRead: true
    },
    {
      id: 14,
      from: {
        email: 'duong.van.khoa@ioc.gov.vn',
        name: 'Dương Văn Khoa',
        avatar: require('@src/assets/images/portrait/small/avatar-s-9.jpg').default
      },
      to: [
        {
          name: 'tôi',
          email: 'phan.thi.linh@ioc.gov.vn'
        }
      ],
      subject: 'Tình hình chỉ tiêu cộng đồng - Phong trào xây dựng khu dân cư văn hóa',
      cc: [],
      bcc: [],
      message:
        '<p>Kính gửi chị Linh,</p><p>Tôi xin báo cáo tình hình các chỉ tiêu IOC lĩnh vực Cộng đồng, đặc biệt về phong trào xây dựng khu dân cư văn hóa. Đến nay, toàn thành phố có 1.245/1.892 khu phố văn hóa đạt tiêu chuẩn (chiếm 65,8%), tăng 4,2% so với năm ngoái. Tỷ lệ gia đình văn hóa đạt 87,3%.</p><p>Số hộ nghèo giảm còn 1,2% tổng số hộ, đạt mục tiêu đề ra. Tỷ lệ hộ tham gia bảo hiểm y tế đạt 92,4%, tỷ lệ hộ sử dụng nước sạch đạt 99,1%. Phong trào "Người dân tham gia quản lý đô thị" thu hút 245.680 tình nguyện viên đăng ký tham gia. Hệ thống IOC đã tích hợp kênh tiếp nhận phản ánh từ cộng đồng với 3.421 ý kiến trong tháng.</p><p>Đề nghị chị tổng hợp báo cáo để trình Ban Chỉ đạo phong trào thi đua trong tuần tới.</p><p>Trân trọng,<br/>Dương Văn Khoa<br/>Ban Cộng đồng - IOC</p>',
      attachments: [],
      isStarred: false,
      labels: ['company'],
      time: 'Tue Jan 06 2018 23:12:13 GMT+0000 (GMT)',
      replies: [],
      folder: 'inbox',
      isRead: true
    },
    {
      id: 15,
      from: {
        email: 'phan.thi.linh@ioc.gov.vn',
        name: 'Phan Thị Linh',
        avatar: require('@src/assets/images/avatars/9.png').default
      },
      to: [
        {
          name: 'tôi',
          email: 'nguyen.van.an@ioc.gov.vn'
        }
      ],
      subject: 'Kết quả đo lường chỉ tiêu du lịch tháng cuối năm 🎉 🎊',
      cc: [],
      bcc: [],
      message:
        '<p>Kính gửi anh An,</p><p>Tôi xin chia sẻ kết quả tích cực từ các chỉ tiêu IOC lĩnh vực Du lịch tháng 12. Số lượng khách du lịch đến thành phố đạt 1.892.450 lượt, tăng 28% so với cùng kỳ năm ngoái. Khách quốc tế đạt 412.680 lượt, tăng 45%. Tổng doanh thu từ du lịch ước đạt 8.920 tỷ đồng, tăng 32%.</p><p>Chỉ số hài lòng của khách du lịch đạt 4,2/5 điểm, tăng 0,3 điểm so với năm ngoái. Tỷ lệ khách quay lại đạt 38,7%. Hệ thống IOC ghi nhận công suất phòng khách sạn trung bình đạt 85,4%, cao nhất trong 3 năm qua. Các điểm đến nội địa hàng đầu là khu phố cổ, Dinh Độc Lập và các bảo tàng lịch sử.</p><p>Đề nghị anh ghi nhận kết quả tích cực này và tiếp tục theo dõi để duy trì đà tăng trưởng trong mùa Tết sắp tới.</p><p>Trân trọng,<br/>Phan Thị Linh<br/>Phòng Du lịch - IOC</p>',
      attachments: [],
      isStarred: false,
      labels: ['company'],
      time: 'Tue Jan 07 2018 12:25:03 GMT+0000 (GMT)',
      replies: [],
      folder: 'inbox',
      isRead: false
    },
    {
      id: 16,
      from: {
        email: 'tran.thi.binh@ioc.gov.vn',
        name: 'Trần Thị Bình',
        avatar: require('@src/assets/images/avatars/2.png').default
      },
      to: [
        {
          name: 'tôi',
          email: 'le.minh.chau@ioc.gov.vn'
        }
      ],
      subject: 'Tổng kết chỉ tiêu giao thông thông minh - Hệ thống đèn tín hiệu thích ứng',
      cc: [],
      bcc: [],
      message:
        '<p>Kính gửi anh Châu,</p><p>Tôi xin gửi tổng kết kết quả triển khai hệ thống đèn tín hiệu giao thông thích ứng thông minh theo chỉ tiêu IOC. Sau 6 tháng vận hành, hệ thống đã được lắp đặt tại 245 nút giao thông trên địa bàn thành phố. Thời gian chờ trung bình tại các nút giao có hệ thống thích ứng giảm 23,4% so với hệ thống cũ.</p><p>Số vụ tai nạn giao thông tại các nút giao có lắp đặt hệ thống giảm 31,2%. Mức độ ùn tắc vào giờ cao điểm giảm từ 67% xuống còn 48%. Tốc độ di chuyển trung bình trên các tuyến đường chính tăng từ 18 km/h lên 24 km/h. Hệ thống IOC đã tự động điều chỉnh chu kỳ đèn 12.450 lần trong tháng dựa trên dữ liệu thực tế.</p><p>Đề nghị anh xem xét và mở rộng triển khai tại 100 nút giao tiếp theo trong quý 1/2024.</p><p>Trân trọng,<br/>Trần Thị Bình<br/>Phòng Giao thông Thông minh - IOC</p>',
      attachments: [],
      isStarred: false,
      labels: ['company'],
      time: 'Tue Jan 08 2018 00:36:40 GMT+0000 (GMT)',
      replies: [],
      folder: 'sent',
      isRead: true
    },
    {
      id: 17,
      from: {
        email: 'vu.quang.minh@ioc.gov.vn',
        name: 'Vũ Quang Minh',
        avatar: require('@src/assets/images/avatars/9.png').default
      },
      to: [
        {
          name: 'tôi',
          email: 'do.thi.thu@ioc.gov.vn'
        }
      ],
      subject: 'Chỉ tiêu hạ tầng số - Tỷ lệ phủ sóng 5G và kết nối internet',
      cc: [],
      bcc: [],
      message:
        '<p>Kính gửi chị Thu,</p><p>Tôi xin cập nhật các chỉ tiêu IOC lĩnh vực Hạ tầng Số. Tỷ lệ phủ sóng 4G/5G trên địa bàn thành phố hiện đạt 98,7% diện tích đô thị và 89,4% diện tích nông thôn ngoại thành. Số thuê bao di động băng rộng đạt 11,2 triệu, tương đương 121% dân số.</p><p>Tỷ lệ hộ gia đình có kết nối internet băng thông rộng cố định đạt 82,4%, tăng 6,1% so với năm ngoái. Tốc độ internet trung bình đạt 68,5 Mbps (tăng 15 Mbps). Hạ tầng IoT toàn thành phố có 245.680 thiết bị kết nối, trong đó 45.320 thiết bị phục vụ quản lý thành phố thông minh. Cần đầu tư thêm 12 trạm thu phát sóng tại khu vực vùng sâu vùng xa.</p><p>Đề nghị chị phối hợp với Sở TT&TT để lập kế hoạch mở rộng hạ tầng số trong năm 2024.</p><p>Trân trọng,<br/>Vũ Quang Minh<br/>Phòng Hạ tầng Số - IOC</p>',
      attachments: [],
      isStarred: false,
      labels: ['personal'],
      time: 'Tue Jan 09 2018 22:06:50 GMT+0000 (GMT)',
      replies: [],
      folder: 'spam',
      isRead: true
    },
    {
      id: 18,
      from: {
        email: 'bui.van.hung@ioc.gov.vn',
        name: 'Bùi Văn Hùng',
        avatar: require('@src/assets/images/avatars/6.png').default
      },
      to: [
        {
          name: 'tôi',
          email: 'ngo.thi.huong@ioc.gov.vn'
        }
      ],
      subject: 'Cảnh báo chỉ tiêu ô nhiễm nguồn nước - Yêu cầu kiểm tra khẩn',
      cc: [],
      bcc: [],
      message:
        '<p>Kính gửi chị Hương,</p><p>Hệ thống quan trắc môi trường IOC vừa phát hiện dấu hiệu ô nhiễm nguồn nước tại 3 điểm lấy mẫu trên kênh Nhiêu Lộc - Thị Nghè. Nồng độ coliform tổng số vượt ngưỡng cho phép 4,2 lần, DO (oxy hòa tan) giảm xuống còn 2,1 mg/L (ngưỡng an toàn là 4 mg/L). pH đo được là 5,8, thấp hơn tiêu chuẩn.</p><p>Nguyên nhân nghi ngờ là nước thải từ 2 cơ sở sản xuất thực phẩm gần đó chưa qua xử lý đúng quy trình. Hệ thống IOC đã gửi cảnh báo tự động đến Sở TN&MT và yêu cầu lấy mẫu xác minh. Tình trạng này ảnh hưởng đến chỉ tiêu tỷ lệ nguồn nước đạt tiêu chuẩn (hiện giảm xuống 94,2% từ 97,8%).</p><p>Đề nghị chị chỉ đạo kiểm tra khẩn và xử lý nguồn xả thải vi phạm theo quy định.</p><p>Trân trọng,<br/>Bùi Văn Hùng<br/>Ban Môi trường - IOC</p>',
      attachments: [],
      isStarred: true,
      labels: ['personal'],
      time: 'Tue Jan 10 2018 01:51:24 GMT+0000 (GMT)',
      replies: [],
      folder: 'spam',
      isRead: true
    },
    {
      id: 19,
      from: {
        email: 'ly.van.phong@ioc.gov.vn',
        name: 'Lý Văn Phong',
        avatar: require('@src/assets/images/avatars/8.png').default
      },
      to: [
        {
          name: 'tôi',
          email: 'dinh.thi.nga@ioc.gov.vn'
        }
      ],
      subject: 'Kết quả chỉ tiêu e-Gov - Chuyển đổi số dịch vụ hành chính công',
      cc: [],
      bcc: [],
      message:
        '<p>Kính gửi chị Nga,</p><p>Tôi xin chia sẻ kết quả triển khai chuyển đổi số dịch vụ hành chính công theo chỉ tiêu IOC lĩnh vực E-Gov. Đến hết tháng 12, có 85,4% dịch vụ công đủ điều kiện đã được triển khai ở mức độ 3 và 4 (trực tuyến toàn trình), tăng 12,3% so với đầu năm. Tổng số giao dịch trực tuyến trong tháng đạt 1.245.680 giao dịch.</p><p>Ứng dụng di động của thành phố đã có 892.450 lượt tải về và 345.120 người dùng hoạt động thường xuyên. Tỷ lệ hồ sơ nộp trực tuyến đạt 71,3%, tăng 18% so với năm ngoái. Chỉ số chuyển đổi số của thành phố xếp hạng 2/63 tỉnh thành cả nước. Hệ thống IOC tích hợp dữ liệu từ 42 sở ngành và 22 quận huyện.</p><p>Đề nghị chị tiếp tục theo dõi và đôn đốc các đơn vị hoàn thiện chỉ tiêu chuyển đổi số theo lộ trình.</p><p>Trân trọng,<br/>Lý Văn Phong<br/>Ban Chuyển đổi Số - IOC</p>',
      attachments: [],
      isStarred: true,
      labels: ['personal'],
      time: 'Tue Jan 11 2018 14:25:46 GMT+0000 (GMT)',
      replies: [],
      folder: 'spam',
      isRead: false
    },
    {
      id: 20,
      from: {
        email: 'to.xuan.truong@ioc.gov.vn',
        name: 'Tô Xuân Trường',
        avatar: require('@src/assets/images/avatars/9.png').default
      },
      to: [
        {
          name: 'tôi',
          email: 'cao.thi.mai@ioc.gov.vn'
        }
      ],
      subject: 'Báo cáo chỉ tiêu rủi ro đô thị - Quản lý và ứng phó thảm họa',
      cc: [],
      bcc: [],
      message:
        '<p>Kính gửi chị Mai,</p><p>Tôi xin báo cáo đánh giá rủi ro đô thị định kỳ theo chỉ tiêu IOC lĩnh vực Quản lý Rủi ro. Hệ thống cảnh báo sớm IOC đã xác định 14 khu vực có nguy cơ ngập lụt cao trong mùa mưa sắp tới, tập trung ở các quận thấp triều. Tổng diện tích có nguy cơ ngập là 124 km², ảnh hưởng đến khoảng 245.000 hộ dân.</p><p>Chỉ số rủi ro địa chất ghi nhận 8 khu vực có nguy cơ sụt lún đất do khai thác nước ngầm quá mức. Tỷ lệ dân số sống trong vùng rủi ro thiên tai là 18,4%. Hệ thống cảnh báo sớm đã hoạt động với độ chính xác 94,2% trong năm qua. Kế hoạch ứng phó khẩn cấp cần được cập nhật cho 7 kịch bản thiên tai chính.</p><p>Đề nghị chị phê duyệt kế hoạch diễn tập ứng phó rủi ro đô thị dự kiến tổ chức vào tháng 3/2024.</p><p>Trân trọng,<br/>Tô Xuân Trường<br/>Ban Quản lý Rủi ro - IOC</p>',
      attachments: [
        {
          fileName: 'ban-do-rui-ro-do-thi.js',
          thumbnail: require('@src/assets/images/icons/js.png').default,
          url: '',
          size: '4mb'
        }
      ],
      isStarred: false,
      labels: ['private'],
      time: 'Tue Jan 12 2018 04:16:10 GMT+0000 (GMT)',
      replies: [],
      folder: 'spam',
      isRead: false
    },
    {
      id: 21,
      from: {
        email: 'cao.thi.mai@ioc.gov.vn',
        name: 'Cao Thị Mai',
        avatar: require('@src/assets/images/portrait/small/avatar-s-9.jpg').default
      },
      to: [
        {
          name: 'tôi',
          email: 'duong.van.khoa@ioc.gov.vn'
        }
      ],
      subject: 'Chỉ tiêu đăng kiểm phương tiện - Tỷ lệ phương tiện quá hạn 📷 😃',
      cc: [],
      bcc: [],
      message:
        '<p>Kính gửi anh Khoa,</p><p>Theo dữ liệu hệ thống IOC lĩnh vực Đăng kiểm Phương tiện, hiện có 124.680 phương tiện cơ giới đã quá hạn đăng kiểm trên địa bàn thành phố, chiếm 8,7% tổng số phương tiện đăng ký. Trong số này, 45.320 phương tiện quá hạn trên 6 tháng cần được xử lý ưu tiên.</p><p>Hệ thống IOC đã tự động gửi 89.450 thông báo nhắc nhở đến chủ phương tiện qua email và SMS. Tỷ lệ phương tiện đến đăng kiểm sau khi nhận thông báo đạt 67,3%. Số xe ô tô tải quá hạn đăng kiểm đang lưu thông trên đường là 12.340 xe, tiềm ẩn nguy cơ tai nạn giao thông cao. Camera giám sát giao thông đã phát hiện 2.890 phương tiện quá hạn đăng kiểm vi phạm.</p><p>Đề nghị anh phối hợp với Cục Đăng kiểm và CSGT để xử lý triệt để tình trạng phương tiện quá hạn đăng kiểm lưu thông.</p><p>Trân trọng,<br/>Cao Thị Mai<br/>Phòng Đăng kiểm - IOC</p>',
      attachments: [],
      isStarred: true,
      labels: ['company'],
      time: new Date(new Date().getTime() - 7 * 60 * 60 * 1000),
      replies: [],
      folder: 'inbox',
      isRead: false
    },
    {
      id: 22,
      from: {
        email: 'duong.van.khoa@ioc.gov.vn',
        name: 'Dương Văn Khoa',
        avatar: require('@src/assets/images/avatars/8.png').default
      },
      to: [
        {
          name: 'tôi',
          email: 'phan.thi.linh@ioc.gov.vn'
        }
      ],
      subject: 'Dự thảo kế hoạch tổng kết chỉ tiêu IOC năm 2023 💻',
      cc: [],
      bcc: [],
      message:
        '<p>Kính gửi chị Linh,</p><p>Tôi xin gửi dự thảo kế hoạch tổng kết thực hiện các chỉ tiêu IOC năm 2023 để chị góp ý trước khi trình lãnh đạo phê duyệt. Theo đánh giá sơ bộ, trong tổng số 245 chỉ tiêu IOC theo dõi trong năm, có 198 chỉ tiêu đạt và vượt kế hoạch (chiếm 80,8%), 32 chỉ tiêu đạt (13,1%) và 15 chỉ tiêu chưa đạt (6,1%).</p><p>Các lĩnh vực đạt kết quả tốt nhất: Du lịch (92,3% chỉ tiêu đạt), Dịch vụ công (89,7%), Giao thông thông minh (87,4%). Các lĩnh vực cần cải thiện: Môi trường (71,2% chỉ tiêu đạt), Quy hoạch đô thị (73,5%), PCCC (75,8%). Tổng chi phí vận hành hệ thống IOC trong năm là 125,4 tỷ đồng, tiết kiệm 18% so với năm 2022 nhờ tối ưu hóa quy trình.</p><p>Đề nghị chị xem xét và phản hồi dự thảo trước ngày 25/12 để kịp hoàn thiện tài liệu.</p><p>Trân trọng,<br/>Dương Văn Khoa<br/>Văn phòng IOC</p>',
      attachments: [],
      isStarred: false,
      labels: ['company'],
      time: new Date(new Date().getTime() - 5 * 20 * 60 * 1000),
      replies: [],
      folder: 'draft',
      isRead: false
    },
    {
      id: 23,
      from: {
        email: 'phan.thi.linh@ioc.gov.vn',
        name: 'Phan Thị Linh',
        avatar: require('@src/assets/images/avatars/3.png').default
      },
      to: [
        {
          name: 'tôi',
          email: 'nguyen.van.an@ioc.gov.vn'
        }
      ],
      subject: 'Chỉ tiêu tài sản IoT - Quản lý thiết bị thành phố thông minh',
      cc: [],
      bcc: [],
      message:
        '<p>Kính gửi anh An,</p><p>Tôi xin báo cáo tình hình quản lý tài sản IoT theo chỉ tiêu IOC. Hiện toàn thành phố có 892.450 thiết bị IoT đã được đăng ký và quản lý trên hệ thống, bao gồm camera giám sát (245.680 thiết bị), cảm biến môi trường (124.320 thiết bị), đồng hồ điện/nước thông minh (412.680 thiết bị) và thiết bị khác (109.770 thiết bị).</p><p>Tỷ lệ thiết bị hoạt động bình thường đạt 94,7%, 4,8% đang bảo trì và 0,5% hư hỏng cần thay thế. Dữ liệu từ các thiết bị IoT được thu thập và xử lý trung bình 2,8 triệu điểm dữ liệu/phút. Hệ thống phát hiện 127 thiết bị có hành vi bất thường trong tháng, đã xử lý 89,8%. Cần bổ sung thêm 12.450 thiết bị cảm biến tại các khu vực còn thiếu.</p><p>Đề nghị anh xem xét ngân sách bổ sung thiết bị IoT cho năm 2024 theo kế hoạch đã đề xuất.</p><p>Trân trọng,<br/>Phan Thị Linh<br/>Ban Quản lý IoT - IOC</p>',
      attachments: [
        {
          fileName: 'danh-sach-thiet-bi-iot.xls',
          thumbnail: require('@src/assets/images/icons/xls.png').default,
          url: '',
          size: '33mb'
        }
      ],
      isStarred: false,
      labels: ['private'],
      time: new Date(new Date().getTime() - 2 * 60 * 60 * 1000),
      replies: [],
      folder: 'trash',
      isRead: false
    },
    {
      id: 24,
      from: {
        email: 'nguyen.van.an@ioc.gov.vn',
        name: 'Nguyễn Văn An',
        avatar: require('@src/assets/images/avatars/1.png').default
      },
      to: [
        {
          name: 'tôi',
          email: 'tran.thi.binh@ioc.gov.vn'
        }
      ],
      subject: 'Tổng hợp chỉ tiêu tuân thủ pháp luật - Kết quả kiểm tra năm 2023 😊',
      cc: [],
      bcc: [],
      message:
        '<p>Kính gửi chị Bình,</p><p>Tôi xin gửi tổng hợp kết quả kiểm tra chỉ tiêu tuân thủ pháp luật trên địa bàn thành phố năm 2023. Theo dữ liệu tổng hợp từ hệ thống IOC, tổng số cuộc kiểm tra được tiến hành trong năm là 45.680 cuộc, tăng 18% so với năm 2022. Tỷ lệ đơn vị, cá nhân tuân thủ đúng quy định đạt 87,4%, tăng 3,2% so với năm trước.</p><p>Lĩnh vực có tỷ lệ tuân thủ cao nhất: Vệ sinh an toàn thực phẩm (92,1%), Xây dựng (89,3%), Phòng cháy chữa cháy (88,7%). Lĩnh vực có tỷ lệ tuân thủ thấp: Môi trường (78,4%), Giao thông (81,2%). Tổng số vi phạm bị xử lý: 12.450 vụ, tổng tiền phạt 245,8 tỷ đồng. Hệ thống IOC đã hỗ trợ phát hiện 3.240 vụ vi phạm qua camera và cảm biến.</p><p>Đề nghị chị xem xét và phê duyệt báo cáo để trình lãnh đạo UBND thành phố trong tuần tới.</p><p>Trân trọng,<br/>Nguyễn Văn An<br/>Phòng Quản lý Tuân thủ - IOC</p>',
      attachments: [
        {
          fileName: 'bao-cao-tuan-thu-2023.doc',
          thumbnail: require('@src/assets/images/icons/doc.png').default,
          url: '',
          size: '21mb'
        }
      ],
      isStarred: false,
      labels: ['personal'],
      time: new Date(new Date().getTime() - 1 * 30 * 60 * 1000),
      replies: [
        {
          id: 25,
          from: {
            email: 'tran.thi.binh@ioc.gov.vn',
            name: 'Trần Thị Bình',
            avatar: require('@src/assets/images/avatars/11.png').default
          },
          to: [
            {
              name: 'tôi',
              email: 'nguyen.van.an@ioc.gov.vn'
            }
          ],
          subject: '🎯 Phản hồi báo cáo tuân thủ pháp luật năm 2023',
          cc: [],
          bcc: [],
          message:
            '<p>Kính gửi anh An,</p><p>Tôi đã xem xét báo cáo tổng hợp chỉ tiêu tuân thủ pháp luật năm 2023. Nhìn chung, kết quả rất tích cực với tỷ lệ tuân thủ tổng thể tăng đáng kể. Tuy nhiên, tôi có một số góp ý để hoàn thiện báo cáo trước khi trình lãnh đạo.</p><p>Thứ nhất, cần bổ sung thêm phân tích nguyên nhân vi phạm tại 2 lĩnh vực có tỷ lệ thấp là Môi trường và Giao thông. Thứ hai, số liệu về tiền phạt cần được đối chiếu với báo cáo tài chính của Kho bạc Nhà nước để đảm bảo tính chính xác. Thứ ba, cần có thêm biểu đồ so sánh xu hướng tuân thủ qua các năm từ 2020-2023 để thấy rõ hơn sự cải thiện.</p><p>Đề nghị anh bổ sung các nội dung trên và gửi lại bản hoàn chỉnh trước ngày 22/12.</p><p>Trân trọng,<br/>Trần Thị Bình<br/>Phó Giám đốc IOC</p>',
          attachments: [],
          isStarred: false,
          labels: [],
          time: 'Mon Dec 10 2018 10:56:00 GMT+0000 (GMT)',
          replies: [],
          folder: 'inbox',
          isRead: false
        },
        {
          id: 26,
          from: {
            email: 'le.minh.chau@ioc.gov.vn',
            name: 'Lê Minh Châu',
            avatar: require('@src/assets/images/avatars/3.png').default
          },
          to: [
            {
              name: 'tôi',
              email: 'tran.thi.binh@ioc.gov.vn'
            }
          ],
          subject: 'Bổ sung số liệu lĩnh vực Giao thông vào báo cáo tuân thủ',
          cc: [],
          bcc: [],
          message:
            '<p>Kính gửi chị Bình,</p><p>Tôi xin bổ sung số liệu phân tích lĩnh vực Giao thông theo yêu cầu. Nguyên nhân chính khiến tỷ lệ tuân thủ giao thông chỉ đạt 81,2% là do: (1) Ý thức chấp hành luật giao thông của người tham gia giao thông còn hạn chế, đặc biệt tại các tuyến đường ngoại ô; (2) Hệ thống camera giám sát chưa phủ kín toàn bộ địa bàn; (3) Lực lượng CSGT còn mỏng so với số lượng phương tiện ngày càng tăng.</p><p>Các giải pháp đề xuất: Tăng cường lắp đặt camera tại 120 điểm còn thiếu; Triển khai hệ thống phạt nguội tự động tại 45 nút giao thông trọng điểm; Tăng cường tuyên truyền ý thức chấp hành luật giao thông thông qua các kênh truyền thông của thành phố. Hệ thống IOC dự báo nếu triển khai đồng bộ các giải pháp, tỷ lệ tuân thủ giao thông có thể tăng lên 88% vào năm 2024.</p><p>Trân trọng,<br/>Lê Minh Châu<br/>Trưởng phòng Giao thông - IOC</p>',
          attachments: [],
          isStarred: false,
          labels: [],
          time: 'Mon Dec 10 2018 11:25:00 GMT+0000 (GMT)',
          replies: [],
          folder: 'inbox',
          isRead: false
        }
      ],
      folder: 'inbox',
      isRead: true
    }
  ]
}

// ------------------------------------------------
// GET: Return Emails
// ------------------------------------------------
mock.onGet('/apps/email/emails').reply(config => {
  const { q = '', folder = 'inbox', label } = config.params

  const queryLowered = q.toLowerCase()

  function isInFolder(email) {
    if (folder === 'trash') return email.folder === 'trash'
    if (folder === 'starred') return email.isStarred && email.folder !== 'trash'
    return email.folder === (folder || email.folder) && email.folder !== 'trash'
  }

  const filteredData = data.emails.filter(
    email =>
      /* eslint-disable operator-linebreak, implicit-arrow-linebreak */
      email.subject.toLowerCase().includes(queryLowered) &&
      isInFolder(email) &&
      (label ? email.labels.includes(label) : true)
  )
  /* eslint-enable  */

  // ------------------------------------------------
  // Email Meta
  // ------------------------------------------------
  const emailsMeta = {
    inbox: data.emails.filter(email => !email.isDeleted && !email.isRead && email.folder === 'inbox').length,
    draft: data.emails.filter(email => email.folder === 'draft').length,
    spam: data.emails.filter(email => !email.isDeleted && !email.isRead && email.folder === 'spam').length
  }

  return [
    200,
    {
      emails: filteredData.reverse(),
      emailsMeta
    }
  ]
})

// ------------------------------------------------
// POST: Update Email
// ------------------------------------------------
mock.onPost('/apps/email/update-emails').reply(config => {
  const { emailIds, dataToUpdate } = JSON.parse(config.data)
  function updateMailData(email) {
    Object.assign(email, dataToUpdate)
  }

  data.emails.forEach(email => {
    if (emailIds.includes(email.id)) updateMailData(email)
  })

  return [200]
})

// ------------------------------------------------
// POST: Update Emails Label
// ------------------------------------------------
mock.onPost('/apps/email/update-emails-label').reply(config => {
  const { emailIds, label } = JSON.parse(config.data)

  function updateMailLabels(email) {
    const labelIndex = email.labels.indexOf(label)

    if (labelIndex === -1) email.labels.push(label)
    else email.labels.splice(labelIndex, 1)
  }

  data.emails.forEach(email => {
    if (emailIds.includes(email.id)) updateMailLabels(email)
  })

  return [200]
})

// ------------------------------------------------
// GET: GET Single Email
// ------------------------------------------------
mock.onGet('/apps/email/get-email').reply(config => {
  const { id } = config

  const emailId = Number(id)

  const mail = data.emails.find(i => i.id === emailId)
  const mailIndex = data.emails.findIndex(i => i.id === mail.id)
  mailIndex === 0 ? (mail.hasPreviousMail = true) : (mail.hasPreviousMail = false)
  mailIndex === data.emails.length - 1 ? (mail.hasNextMail = true) : (mail.hasNextMail = false)

  return mail ? [200, mail] : [404]
})

// ------------------------------------------------
// GET: Paginate Existing Email
// ------------------------------------------------
mock.onGet('/apps/email/paginate-email').reply(config => {
  const { dir, emailId } = config.params

  const currentEmailIndex = data.emails.findIndex(e => e.id === emailId)

  const newEmailIndex = dir === 'previous' ? currentEmailIndex - 1 : currentEmailIndex + 1

  const newEmail = data.emails[newEmailIndex]

  return newEmail ? [200, newEmail] : [404]
})
/* eslint-enable */
